// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerBooking_Page__27Ilo","Selection":"ManagerBooking_Selection__1Kkyk"};